import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createDirectors = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/common?table=directors&`, data);
  return res.data;
};
export const getAllDirectors = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/common?table=directors`
  );
  return res.data;
};
export const getDirectorById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/employee/${id}`);
  return res.data;
};
export const createDirectorsLoanCapital = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/common?table=directors_loan_capital&`, data);
  return res.data;
};
export const getDirectorsLoanCapitalById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/common/${id}?table=directors_loan_capital`);
  return res.data;
};

export const updateLoanCapitalById = async (id,data) => {
  const res = await axios.patch(`${API_BASE_URL}/common?table=directors_loan_capital&id=${id}`,data);
  return res.data;
};
